import React, {useState} from "react";
import FormBuilder from "../../../class/tool/FormBuilder"

const PaymentMethodFormSheet = props => {
    const { values, errors, predefinedPaymentMethods, updated, setGlobalError, handleChange, handleSave } = props
    const [ edit, setEdit ] = useState("")
    const [ rows, setRows ] = useState([
        {
            label: "Type prédéfini",
            attribute: "predefined_payment_method_id",
            inputType: "select",
            returnType: "int",
            list: predefinedPaymentMethods,
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Nom",
            attribute: "name",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "Nom",
            emptyText: "Aucun"
        },
        {
            label: "Référence",
            attribute: "reference",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "Référence",
            emptyText: "Aucune"
        },
        {
            noLabel: true,
            label: "Ouvrir le tiroir caisse",
            attribute: "openCashRegister",
            inputType: "switch",
            returnType: "int",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "Générer un avoir",
            attribute: "assetManagement",
            inputType: "switch",
            returnType: "int",
            classnameInput: ""
        },
        {
            label: "Lier à un matériel",
            attribute: "peripheralTarget",
            inputType: "select",
            returnType: "string",
            list: [
                {
                    value: "Aucun",
                    id: null
                }, {
                    value: "----------",
                    id: null
                }, {
                    value: "tpe",
                    id: 1
                }, {
                    value: "glory",
                    id: 2
                }
            ],
            dictionary: {
                "": "Aucun",
                "Aucun": "Aucun",
                "----------": "----------",
                "tpe": "TPE",
                "glory": "Monnayeur automatique"
            },
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        }
    ]);

    const buildRow = row => {
        if (edit === row.attribute || ["switch"].includes(row.inputType))
            return FormBuilder.buildInputByType(row, values, errors, change, reinitEdit);
        else
            return FormBuilder.buildNoInputByType(row, values, handleEdit);
    }
    const handleEdit = attribute => {
        setEdit(attribute);
    }
    const change = (attribute, returnType, val, strict = false) => {
        handleChange(rows, attribute, returnType, val, strict);
    }
    const reinitEdit = () => {
        setEdit("");
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault();
        handleSave();
    }

    return (
        <form
            className={"form inOverbox"}
            onSubmit={ handleSubmit } >
            {
                rows.map((row, index) => (
                    <div key={ index } className="clearing">
                        {
                            (row.hidden === undefined || !row.hidden)
                            && <div className="clearing">
                                {
                                    row.noLabel === undefined
                                    && <label className={ row.classnameLabel }>{ row.label }</label>
                                }
                                {
                                    buildRow(row)
                                }
                            </div>
                        }
                    </div>
                ))
            }
        </form>
    );
}

export default PaymentMethodFormSheet;
